import { Injectable } from '@angular/core';

import { WithheldIncomeTax } from '../../models/withheld-income-tax';

import { HttpClientService } from '../common/http-client.service';

@Injectable()
export class WithheldIncomeTaxService {
  private url: string = 'withheld_income_taxes';

  constructor(private httpClient: HttpClientService) {}

  delete(id: number): Promise<any> {
    return this.httpClient.delete(`${this.url}/${id}.json`);
  }

  edit(id: number): Promise<any> {
    return this.httpClient.get(`${this.url}/${id}/edit.json`);
  }

  index(params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, params);
  }

  save(withheldIncomeTax: WithheldIncomeTax): Promise<any> {
    if (withheldIncomeTax.id) return this.httpClient.put(`${this.url}/${withheldIncomeTax.id}.json`, { withheld_income_tax: withheldIncomeTax });
    else return this.httpClient.post(`${this.url}.json`, { withheld_income_tax: withheldIncomeTax });
  }
}
